<template>

</template>
<script>

  import {createObjectByEval} from '@/utils/commonUtils'
  import {isEqual, merge} from 'lodash'

  export default {
    name: "multi-entities-czml-data-source",
    props: {
      cesiumId: {
        type: String,
        default: "default"
      },
      czmlDataSourcesId: {
        type: String,
        default: "default"
      },
      maxDiffTimeForUpdate: {
        type: Number,
        default: -1
      },
      czmlParamsPromiseFun: {
        type: Function,
        default: () => Promise.resolve({})
      },
      entities: {//объект должен быть иммутабелен
        type: Array,
        default: () => []
      },
      entityCzmlTemplate: {
        type: Object | Array,
        default: () => {
          return []
        }
      }
    },
    data: () => {
      return {
        lastTimeUpdate: undefined
      }
    },

    mounted() {
      this.updateCzmlForEntities(this.entities, window.cesiumViewer[this.cesiumId].getCzmlDataSource(this.czmlDataSourcesId))
    },

    methods: {
      updateCzmlForEntities(entities, czmlDataSource) {

        if(!entities.length) return;

        for (let i = 0; i < entities.length; i++)
          if (!entities[i].length) return;

        const self = this;

        const currentTime = Cesium.JulianDate.toDate(window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock.currentTime).getTime();

        this.lastTimeUpdate = currentTime;

        const asyncRequests = [];//TODO продумать cancel

        let joinedEntities = this.joinEntities(entities);

        joinedEntities.forEach(entities => {
          const asyncRequest = self.czmlParamsPromiseFun(entities, currentTime);

          asyncRequests.push(asyncRequest);

          asyncRequest.then(czmlParams => {
            if (Array.isArray(this.entityCzmlTemplate))
              this.entityCzmlTemplate.forEach(template => addCzmlEntity(template));
            else addCzmlEntity(this.entityCzmlTemplate);

            function addCzmlEntity(entityCzmlTemplate) {
              const czml = createObjectByEval(entityCzmlTemplate, merge({
                vue: self,
                entities,
                currentTime
              }, czmlParams));

              czmlDataSource.process(czml, {})
            }

          })
        })
      },

      joinEntities(entities) {
        let f = (a, b) => [].concat(...a.map(a => b.map(b => [].concat(a, b))));
        let cartesian = (a, b, ...c) => b ? cartesian(f(a, b), ...c) : a;

        return cartesian(entities[0], entities[1], entities.length > 2 ? entities.slice(2) : null);
      },

      clockTickHandler(c) {
        const currentTime = Cesium.JulianDate.toDate(c.currentTime).getTime();
        if (this.maxDiffTimeForUpdate !== -1 && Math.abs(currentTime - this.lastTimeUpdate) > this.maxDiffTimeForUpdate) {
          const czmlDataSource = window.cesiumViewer[this.cesiumId].getCzmlDataSource(this.czmlDataSourcesId);
          this.updateCzmlForEntities(this.entities, czmlDataSource)
        }
      },
    },
    watch: {
      entities: {//Должен быть иммутебельный
        immediate: true,
        handler(newEntities, oldEntities) {

          const entitiesForRemove = (oldEntities || []).map((entities, i) => entities.filter(oldEntity => !newEntities[i].find(newEntity => newEntity.id == oldEntity.id)));

          const czmlDataSource = window.cesiumViewer[this.cesiumId].getCzmlDataSource(this.czmlDataSourcesId);

          let joinedEntitiesForRemove = [];

          for (let i = 0; i < entitiesForRemove.length; i++) {
            if (!entitiesForRemove[i].length) continue;
            const oldEntitiesCopy = JSON.parse(JSON.stringify(oldEntities));
            oldEntitiesCopy[i] = entitiesForRemove[i];
            joinedEntitiesForRemove = joinedEntitiesForRemove.concat(this.joinEntities(oldEntitiesCopy))
          }

          const entityIdTemplates = Array.isArray(this.entityCzmlTemplate) ? this.entityCzmlTemplate.map(entityCzmlTemplate => entityCzmlTemplate.id) : [this.entityCzmlTemplate.id]

          entityIdTemplates.forEach(entityIdTemplate =>
            czmlDataSource.process(joinedEntitiesForRemove.map(entities => {
              return {id: createObjectByEval(entityIdTemplate, merge({vue: this, entities})), delete: true}
            }), {}));

          this.updateCzmlForEntities(newEntities, czmlDataSource)
        }
      },
      cesiumId(newCesiumId) {
        throw new Error("Deny change cesiumId");
      }
    },
    created() {
      const clock = window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock;
      clock.onTick.addEventListener(this.clockTickHandler);
    },
    destroyed() {
      const clock = window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock;
      clock.onTick.removeEventListener(this.clockTickHandler);
    }
  }
</script>

<style scoped>

</style>
